// Texty předpokládaného naskladnění (restockDate.js): detail i karta.
export default {
  /** „Naskladnění očekáváme do 8. 10." (datum už končí tečkou) */
  expected: (date) => 'Naskladnění očekáváme do ' + date,
  /** zbytek věty panelu vyprodaného za termínem (detail) */
  detailRest: 'Pohlídáme to za vás a dáme vám vědět e-mailem, jakmile bude znovu k dispozici.',
  // --- čtení nativního textu Shoptetu ---
  /** dostupnost vyprodaného na kartě „Momentálně nedostupné" */
  soldOutRe: /nedostupn/i,
};
